var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.itemsElement, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.visible,
      expression: "item.visible"
    }],
    tag: "component",
    staticClass: "standard-navigation__item",
    attrs: {
      "role": _vm.hasChildren ? 'treeitem' : 'none',
      "aria-expanded": _vm.isExpanded ? 'true' : 'false'
    }
  }, [_c('span', {
    staticClass: "standard-navigation__item-state-icon"
  }, [!_vm.hasChildren && _vm.leafIconContent ? _c('standard-navigation-bullet', {
    attrs: {
      "isChecked": _vm.item.isChecked
    }
  }) : _vm._e(), !_vm.isExpanded && _vm.hasChildren && _vm.closedGroupIconContent ? _c('standard-navigation-bullet', {
    attrs: {
      "customIconClass": "icon-plus"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onActivate.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm.isExpanded && _vm.hasChildren && _vm.openGroupIconContent ? _c('standard-navigation-bullet', {
    attrs: {
      "customIconClass": "icon-minus"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onActivate.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "standard-navigation__item-content-wrapper",
    class: {
      'standard-navigation__item-content-wrapper--with-icon': !_vm.item.children && _vm.item.image && _vm.item.image.length
    }
  }, [_vm.hasChildren ? [_c(_vm.contentElement, {
    ref: "hasChildrenTextLabel",
    tag: "component",
    class: ['standard-navigation__item-name', {
      'standard-navigation__item-name--active': _vm.isActive,
      'standard-navigation__item-name--expanded': _vm.isExpanded,
      'standard-navigation__item-name--group': _vm.hasChildren,
      'standard-navigation__item-name--use-bullets': _vm.useBullets
    }],
    attrs: {
      "aria-expanded": false
    },
    on: {
      "click": _vm.onActivate,
      "!keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.onActivate.apply(null, arguments);
      },
      "keydown": function keydown($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.onMoveFocus.apply(null, arguments);
      },
      "focus": _vm.onFocus
    }
  }, [_vm._v("\n        " + _vm._s(_vm.item.name) + "\n      ")]), _c(_vm.itemsWrapperElement, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isExpanded,
      expression: "isExpanded"
    }],
    tag: "component",
    staticClass: "standard-navigation__item-wrapper",
    attrs: {
      "role": "group"
    }
  }, _vm._l(_vm.item.children, function (itemObj, index) {
    return _c('standard-navigation-item', {
      key: itemObj.id,
      ref: "standard-navigation-item-".concat(index),
      refInFor: true,
      attrs: {
        "item": itemObj,
        "items-element": _vm.itemsElement,
        "items-wrapper-element": _vm.itemsWrapperElement,
        "content-element": _vm.contentElement,
        "leaf-icon-content": _vm.leafIconContent,
        "customIconClass": _vm.closedGroupIconContent ? "icon-plus" : "icon-minus",
        "active-item-id": _vm.activeItemId,
        "focused-tree-item": _vm.focusedTreeItem,
        "update-expanded-flag-on-navigation": _vm.updateExpandedFlagOnNavigation
      },
      on: {
        "tree-item-activated": _vm.onTreeItemActivated,
        "tree-item-received-focus": _vm.onTreeItemReceivedFocus,
        "tree-item-on-move-focus": function treeItemOnMoveFocus($event) {
          return _vm.onTreeItemKeyDown(itemObj, $event);
        },
        "tree-item-on-focus-next-item": function treeItemOnFocusNextItem($event) {
          return _vm.onFocusNextItem(itemObj);
        },
        "tree-item-on-focus-previous-item": function treeItemOnFocusPreviousItem($event) {
          return _vm.onFocusPreviousItem(itemObj);
        },
        "tree-item-focus-parent": _vm.getFocus,
        "tree-view-item-collapse-siblings": _vm.onCollapseSiblings,
        "tree-item-expand-item": _vm.onTreeItemExpandItem,
        "tree-item-collapse-item": _vm.onTreeItemCollapseItem,
        "tree-item-go-to-first": _vm.onTreeItemGoToFirst,
        "tree-item-go-to-last": _vm.onTreeItemGoToLast
      }
    });
  }), 1)] : [_c(_vm.contentElement, {
    ref: "standAloneTextLabel",
    tag: "component",
    class: ['standard-navigation__item-name', {
      'standard-navigation__item-name--active': _vm.isActive,
      'standard-navigation__item-name--leaf': !_vm.hasChildren,
      'standard-navigation__item-name--use-bullets': _vm.useBullets
    }],
    attrs: {
      "role": "tab",
      "aria-selected": _vm.isActive,
      "aria-current": _vm.isActive,
      "aria-controls": "customs-swatch-options",
      "aria-label": _vm.item.name
    },
    on: {
      "click": _vm.onActivate,
      "!keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.onActivate.apply(null, arguments);
      },
      "keydown": function keydown($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.onMoveFocus.apply(null, arguments);
      },
      "focus": _vm.onFocus
    }
  }, [_vm._v("\n        " + _vm._s(_vm.item.name) + "\n      ")]), _vm.item.image && _vm.item.image.length ? _c('div', {
    staticClass: "standard-navigation__item-icon-wrapper"
  }, _vm._l(_vm.item.image, function (imageItem, index) {
    return _c('button', {
      key: "standard-navigation-icon-".concat(index),
      staticClass: "standard-navigation__item-icon",
      class: {
        'standard-navigation__item-icon--edit': imageItem.includes('edit')
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          _vm.onClickIcon(imageItem.includes('edit'));
        }
      }
    }, [_c('span', {
      class: imageItem
    })]);
  }), 0) : _vm._e()]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }